import { OrdersTab } from "./OrdersTab";

interface HistoryTabProps {
  tenantId: string;
  highlightOrderId?: string;
  highlightScriptId?: string;
}

export function HistoryTab({
  tenantId,
  highlightOrderId,
  highlightScriptId,
}: HistoryTabProps) {
  return (
    <OrdersTab
      tenantId={tenantId}
      variant="history"
      highlightOrderId={highlightOrderId}
      highlightScriptId={highlightScriptId}
    />
  );
}
